import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {first, map, Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {getDefaultHttpHeaders} from '../utils/http-headers.utils';

@Injectable({
  providedIn: 'root',
})
export class WalletService {

  BASE_URL = "/wallet";
  private http : HttpClient = inject(HttpClient);

  private createAppleWalletLink(siret: string): Observable<{ liveShortToken: string }> {
    return this.http.post<{ liveShortToken: string }>(`${environment.apiUrl}${this.BASE_URL}/${siret}/apple/link`, {}, { headers: getDefaultHttpHeaders().headers })
      .pipe(first());
  }

  private createGoogleWalletLink(siret: string): Observable<{ liveShortToken: string }> {
    return this.http.post<{ liveShortToken: string }>(
      `${environment.apiUrl}${this.BASE_URL}/${siret}/google/link`,
      {},
      { headers: getDefaultHttpHeaders().headers }
    ).pipe(first());
  }

  getAppleWalletPassDownloadUrl(siret: string): Observable<string> {
    return this.createAppleWalletLink(siret).pipe(
      map(({ liveShortToken }) =>
        `${environment.apiUrl}${this.BASE_URL}/public/${siret}/apple?dlToken=${encodeURIComponent(liveShortToken)}`
      )
    );
  }

  /** Short redirect URL suitable for QR codes (avoids oversized Google JWT). */
  getGoogleWalletPassDownloadUrl(siret: string): Observable<string> {
    return this.createGoogleWalletLink(siret).pipe(
      map(({ liveShortToken }) =>
        `${environment.apiUrl}${this.BASE_URL}/public/${siret}/google?dlToken=${encodeURIComponent(liveShortToken)}`
      )
    );
  }

  getGoogleWalletUrl(siret: string): Observable<{ saveUrl: string }> {
    return this.http.get<{ saveUrl: string }>(
      `${environment.apiUrl}${this.BASE_URL}/${siret}/google`,
      { headers: getDefaultHttpHeaders().headers }
    ).pipe(first());
  }
}
